@if(html) {
  <div [innerHTML]="html"></div>
}